import isNull from 'lodash/isNull';
import cloneDeep from 'lodash/cloneDeep';
import keys from 'lodash/keys';

type Result<T extends object> = { [key in keyof T]: T[key] extends null ? undefined : T[key] };

export const nullToUndefined = <T extends object>(
    obj: T,
): { [key in keyof T]: T[key] extends null ? undefined : T[key] } => {
    const transformed = cloneDeep(obj);

    keys(transformed).forEach(key => {
        if (isNull(transformed[key as keyof T])) {
            // @ts-expect-error
            transformed[key as keyof T] = undefined;
        }
    });

    return transformed as Result<T>;
};
